import api from 'lib/api'
import env from 'lib/env'
import type { User } from 'types/user'
import { getMetricName } from 'utils/page'
import { KEY_USER_STORAGE } from 'utils/constants'
import { cookies, DOMAIN_COOKIE } from 'lib/cookies'

export const handleSignOut = () => {
  const idToken = cookies.get('idToken')

  if (idToken) {
    sessionStorage.removeItem(KEY_USER_STORAGE)
  }

  const fields = cookies.get()
  Object.entries(fields).forEach(([key]) => cookies.remove(key, DOMAIN_COOKIE))
}

export const handleSignIn = async (): Promise<User> => {
  try {
    const response = await api<User>('/user')
    sessionStorage.setItem(KEY_USER_STORAGE, JSON.stringify(response.data))

    return response.data
  } catch (err) {
    console.log(err)

    if (err.status === 401) {
      handleSignOut()
    }
  }

  return null
}

const getLinkParamsAuth = () => {
  const metric = getMetricName()
  const search = window.location.search
  const params = search?.includes('applicationSource=')
    ? search
    : `?applicationSource=${metric}${search?.replace('?', '&')}`

  let link = env.host_auth
  if (!params?.includes('applicationSource=default')) link += params

  return link
}

export const handleToAuth = () => {
  const redirect = location.href
  cookies.set('redirect_url', redirect)
  location.href = getLinkParamsAuth()
}

export const userHasAppliedInTalentBank = async (
  companyId: number
): Promise<boolean> => {
  try {
    const response = await api<{ data: { companyId: number }[] }>(
      '/applicants/my-talent-bases',
      {},
      'applicants'
    )

    const hasApplied = response.data.data.find(
      item => item.companyId === companyId
    )

    return !!hasApplied?.companyId
  } catch (err) {
    console.error(err)
  }

  return false
}
